// extracted by mini-css-extract-plugin
module.exports = {"primeButtonWrap":"__7Jt90lmV","hidden":"DvF4mc87","divider":"__0U2Kub_1","isOutOfStock":"bFDDKIeu"};